// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoxList_wrapper__ZDgDi","title-wrapper":"BoxList_title-wrapper__EfLW5","grid":"BoxList_grid__EC83c"};